import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import PaymentMethodComponent from '../components/payment-method.component';
import { selectStoresListItems } from '../../../../../../redux/stores/selector';
import { stores } from '../../../../../../redux/stores/action';
import { paymentMethods } from '../../../../../../redux/payment-methods/action';
import { deepCopy } from '../../../../../../common/services/common.service';
import { selectPaymentMethodsQueryItems } from '../../../../../../redux/payment-methods/selector';

const ManagementPaymentMethod = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const paymentMethodQuery = useSelector(selectPaymentMethodsQueryItems);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const storeItems = useSelector(selectStoresListItems);
  const [chosenPaymentMethod, setChosenPaymentMethod] = useState<any>([]);
  const [selectRazorpay, setSelectRazorpay] = useState<any>({});
  const [selectCCAVenues, setSelectCCAVenues] = useState<any[]>([
    {
      GatewayName: "",
      MerchantId: "",
      MappedDomain: "",
      WorkingKey: "",
      AccessCode: "",
      IsActive: false
    }
  ]);

  const fetchPaymentMethodQueryById = () => {
    dispatch(paymentMethods.query({
      url: `https://epay.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/configuration/payment-management/payment-methods/fetch-detail`,
      entity: 'paymentMethods',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleBasicInnerFormChange: any = (event: any, field: string) => {
    setChosenPaymentMethod({ ...chosenPaymentMethod, [field]: event });
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectRazorpay({ ...selectRazorpay, [fields[0]]: value });
  }

  const handleCCAvenueFormChange = ({ value, field, idx }: any) => {
    const items = deepCopy(selectCCAVenues);
    let item = items[idx];
    item = { ...item, [field]: value };
    items[idx] = item;
    setSelectCCAVenues(addNewCCAvenueRow({ selectedCCAvenuesArg: items }));
  };

  const addNewCCAvenueRow = ({ selectedCCAvenuesArg }: any) => {
    const localCCAvenues = deepCopy(selectedCCAvenuesArg);
    const newCCAvenue = {
      GatewayName: '',
      WorkingKey: '',
      MerchantId: '',
      AccessCode: '',
      IsActive: false,
      MappedDomain: ''
    };

    if (
      localCCAvenues.length === 0 ||
      localCCAvenues[localCCAvenues.length - 1]?.GatewayName !== ''
    ) {
      localCCAvenues.push(newCCAvenue);
    }

    return localCCAvenues;
  };

  const handleDeleteCCAvenueRow = (idx: number) => {
    let items = deepCopy(selectCCAVenues);
    items.splice(idx, 1);

    if (items.length === 0) {
      items = addNewCCAvenueRow({ selectedCCAvenuesArg: [] });
    }

    setSelectCCAVenues(items);
  };

  useEffect(() => {
    dispatch(stores.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores/list`,
      entity: 'stores',
      jsonData: {}
    })).then(() => {
      if (parmas?.id > 0) {
        fetchPaymentMethodQueryById();
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, [])

  useEffect(() => {
    if (isQuery) {
      setChosenPaymentMethod(paymentMethodQuery?.result?.items);
      setSelectRazorpay({
        PhonePe: paymentMethodQuery?.result?.items?.PhonePe || {},
        RazorPay: paymentMethodQuery?.result?.items?.RazorPay || {}
      });

      const localCCAvenues = addNewCCAvenueRow({
        selectedCCAvenuesArg: paymentMethodQuery?.result?.items?.CCAvenues || []
      });
      setSelectCCAVenues(localCCAvenues);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    // const paymentMethodData = {
    //   Id: chosenPaymentMethod?.RazorPayConfigurationId || 0,
    //   StoreId: chosenPaymentMethod?.StoreId || 0,
    //   GatewayKey: chosenPaymentMethod?.GatewayKey || '',
    //   GatewaySecret: chosenPaymentMethod?.GatewaySecret || '',
    //   GatewayName: chosenPaymentMethod?.GatewayName || '',
    //   IsActive: chosenPaymentMethod?.IsActive || '',
    //   RazorPayConfigurationPId: chosenPaymentMethod?.RazorPayConfigurationPId || '',
    //   RazorPay: selectRazorpay?.RazorPay || {},
    //   CCAvenue: selectRazorpay?.CCAvenue || [],
    //   PhonePe: selectRazorpay?.PhonePe || {}
    // }
    selectCCAVenues.splice(
      selectCCAVenues?.length - 1,
      1
    )
    const paymentMethodData = {
      Id: chosenPaymentMethod?.RazorPayConfigurationId || 0,
      StoreId: chosenPaymentMethod?.StoreId || 0,
      GatewayKey: chosenPaymentMethod?.GatewayKey || '',
      GatewaySecret: chosenPaymentMethod?.GatewaySecret || '',

      RazorPay: {
        GatewayName: selectRazorpay?.RazorPay?.GatewayName || '',
        GatewayKey: selectRazorpay?.RazorPay?.GatewayKey || '',
        GatewaySecret: selectRazorpay?.RazorPay?.GatewaySecret || '',
        IsActive: selectRazorpay?.RazorPay?.IsActive ?? false,
      },

      CCAvenues: selectCCAVenues?.map((cc: any) => ({
        GatewayName: cc.GatewayName || '',
        WorkingKey: cc.WorkingKey || '',
        MerchantId: cc.MerchantId || '',
        AccessCode: cc.AccessCode || '',
        IsActive: cc.IsActive ?? false,
        MappedDomain: cc.MappedDomain || '',
      })),

      PhonePe: {
        GatewayName: selectRazorpay?.PhonePe?.GatewayName || '',
        SaltKey: selectRazorpay?.PhonePe?.SaltKey || '',
        MerchantId: selectRazorpay?.PhonePe?.MerchantId || '',
        SaltIndex: selectRazorpay?.PhonePe?.SaltIndex || '',
        IsActive: selectRazorpay?.PhonePe?.IsActive ?? false,
      }
    };

    if (parmas?.id > 0) {
      await dispatch(paymentMethods.resetAction({ actionType: 'update' }))
      await dispatch(paymentMethods.update({
        url: `https://epay.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/configuration/payment-management/payment-methods`,
        entity: 'paymentMethods',
        jsonData: {
          Context: {},
          Records: [paymentMethodData]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(paymentMethods.resetAction({ actionType: 'create' }))
      await dispatch(paymentMethods.create({
        url: `https://epay.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/configuration/payment-management/payment-methods`,
        entity: 'paymentMethods',
        jsonData: {
          Context: {},
          Records: [paymentMethodData]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/configuration/payment-management/payment-methods')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <PaymentMethodComponent
          chosenPaymentMethod={chosenPaymentMethod}
          stores={storeItems?.result?.items}
          handleInnerFormChange={handleInnerFormChange}
          selectRazorpay={selectRazorpay}
          selectCCAVenues={selectCCAVenues}
          back={back}
          handleFormSubmit={handleFormSubmit}
          handleBasicInnerFormChange={handleBasicInnerFormChange}
          handleCCAvenueFormChange={handleCCAvenueFormChange}
          handleDeleteCCAvenueRow={handleDeleteCCAvenueRow}
        />
      }
    </>
  );
};

export default ManagementPaymentMethod;